import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import EditLocationGeoData from './views/location/EditGeoData.vue'
import UploadDivision from './views/division/UploadDivision.vue'
import UploadActualsPage from './views/plants/UploadActualsPage.vue'

import ForecastProfileTemplatePage from '@/views/plants/configuration/ForecastProfileTemplatePage.vue'
import PlantConfigurationTeamsPage from '@/views/plants/configuration/PlantConfigurationTeamsPage.vue'
import PlantConfigurationUnitsPage from '@/views/plants/configuration/PlantConfigurationUnitsPage.vue'
import PlantConfigurationSeasonsPage from '@/views/plants/configuration/PlantConfigurationSeasonsPage.vue'
import PlantConfigurationAlertsPage from '@/views/plants/configuration/PlantConfigurationAlertsPage.vue'
import PlantConfigurationNotificationSubscribersPage from '@/views/plants/configuration/PlantConfigurationNotificationSubscribersPage.vue'

import PlantActivities from './views/plants/PlantActivityPage.vue'
import CropProfilesPage from '@/views/crops/CropProfilesPage.vue'
import CropAddEditPage from '@/views/crops/CropAddEditPage.vue'
import CropBatchEditEndDatePage from '@/views/crops/CropBatchEditEndDatePage.vue'

import LoginError from './components/authentication/LoginError.vue'
import LoggingIn from './components/authentication/LoggingIn.vue'
import LogOut from './components/authentication/LogOut.vue'
import LoggedOut from './components/authentication/LoggedOut.vue'
import NotAuthorized from './components/authentication/NotAuthorized.vue'

import LocalDataPage from './views/localData/LocalDataPage.vue'

import SprayConfigurationPage from './views/configuration/SprayConfigurationPage.vue'
import SprayManagementPage from './views/spray/SprayManagementPage.vue'
import RosterPage from './views/berriesRoster/RosterPage.vue'
import HarvestPlanPage from './views/harvestPlan/HarvestPlanPage.vue'

import ForecastingPage from './views/forecasting/ForecastingPage.vue'
import RolesSettingsPage from '@/views/configuration/RolesSettingsPage.vue'
import ProductGroupsPage from '@/views/configuration/ProductGroupsPage.vue';
import ContractorExportPage from './views/preceda/ContractorExportPage.vue'
import CropWorkExportPage from './views/preceda/CropWorkExportPage.vue'
import ScountingPage from '@/views/maintenance/ScoutingPage.vue';
import TrapInspectionPage from '@/views/maintenance/TrapInspectionPage.vue';
import PestConfigurationPage from '@/views/maintenance/PestConfigurationPage.vue';
import TrapConfiguragionPage from '@/views/maintenance/TrapConfigurationPage.vue';
import TrapInspectionHistoryPage from '@/views/maintenance/TrapInspectionHistoryPage.vue';
import BerriesforecastnotealertcategoriesPage from '@/views/configuration/BerriesforecastnotealertcategoriesPage.vue'
import TestWeatherPage from './views/test/Weather.vue'
import AttributesPage from '@/views/configuration/AttributesPage.vue'
import AllowanceTypesPage from '@/views/configuration/AllowanceTypesPage.vue';
import HolidaySettingsPage from '@/views/configuration/PublicHolidaySettingsPage.vue';
import ScoutingCropStagesPage from '@/views/configuration/ScoutingCropStagesPage.vue';
import ScoutingScoreScalesPage from '@/views/configuration/ScoutingScoreScalesPage.vue';
import PestClassificationsPage from '@/views/configuration/PestClassificationsPage.vue';
import AssetsPage from '@/views/configuration/AssetsPage.vue'

import PersonnelMovements from "@/components/movement/PersonnelMovements.vue"
import PersonnelMovementsHistory from "@/components/movement/PersonnelMovementsHistory.vue"
import RejectedPunnetsPage from "@/views/rejections/RejectedPunnetsPage.vue"
import PlantConfigurationInductionsPage from '@/views/plants/configuration/PlantConfigurationInductionsPage.vue'

import AttendanceMemberAbsence from "@/views/plants/team/attendance/attendanceMemberAbsence.vue"
import CropWorkAttendanceMemberAbsence from "@/views/plants/team/attendance/cropWorkAttendanceMemberAbsence.vue"
import BreaksAddEditPage from "@/views/plants/team/breaks/BreaksAddEditPage.vue"

import departmentCodeRateList from './components/configuration/departmentCodes/departmentCodeRateList.vue'
import NuPointSprayJobsPage from '@/views/nuPointSpray/NuPointSprayJobsPage.vue'

import authService from "./services/authService"
import store from "./store";
import { GlobalAdminAccessRight, FarmAdminAccessRight } from '@/helpers/globalAdminAccessRight.js';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: "HMS Home",
        permissions: ['Portal Access']
      }
    },
    {
      path: '/login', // This is intercepted, so nothing to display
      name: 'login',
      meta: {
        title: "Login",
      }
    },
    {
      path: '/loggingin', // This is intercepted, so nothing to display
      name: 'loggingin',
      component: LoggingIn,
      meta: {
        title: "Logging In...",
      }
    },
    {
      path: '/loginerror',
      name: 'loginerror',
      component: LoginError,
      meta: {
        title: "Login Error",
      }
    },
    {
      path: '/logout', // This is intercepted, so nothing to display
      name: 'logout',
      component: LogOut,
      meta: {
        title: "Logging Out...",
      }
    },
    {
      path: '/loggedout',
      name: 'loggedout',
      component: LoggedOut,
      meta: {
        title: "Logged Out",
      }
    },
    {
      path: '/notauthorized',
      name: 'notauthorized',
      component: NotAuthorized,
      meta: {
        title: "Not Authorized",
      }
    },
    {
      path: '/localData',
      name: 'localData',
      component: LocalDataPage,
      meta: {
        title: "Local Data Management"
      }
    },
    {
      path: '/location/editgeodatapopup/:LocationID',
      name: 'editLocationPopup',
      component: EditLocationGeoData,
      meta: {
        title: "Edit Location GEO Data",
        isPopup: true
      }
    },
    {
      path: '/plants/uploadActuals/:plantID',
      name: 'uploadActualsPopup',
      component: UploadActualsPage,
      props: true,
      meta: {
        title: "Upload Actuals",
        isPopup: true
      }
    },
    {
      path: '/plants/:plantID/profileTemplates',
      name: 'profileTemplates',
      component: ForecastProfileTemplatePage,
      props: true,
      meta: {
        title: "Profile Templates",
        isPopup: true
      }
    },
    {
      path: '/plants/:plantID/configuration/teams',
      name: 'plantConfigurationTeams',
      component: PlantConfigurationTeamsPage,
      props: true,
      meta: {
        title: "Plant Configuration - Teams",
        isPopup: true
      }
    },
    {
      path: '/plants/:plantID/configuration/units',
      name: 'plantConfigurationUnits',
      component: PlantConfigurationUnitsPage,
      props: true,
      meta: {
        title: "Plant Configuration - Units",
        isPopup: true
      }
    },
    {
      path: '/plants/:plantID/configuration/seasons',
      name: 'plantConfigurationSeasons',
      component: PlantConfigurationSeasonsPage,
      props: true,
      meta: {
        title: "Plant Configuration - Seasons",
        isPopup: true
      }
    },
    {
      path: '/plants/:plantID/configuration/notificationsubscribers',
      name: 'plantConfigurationNotificationSubscribers',
      component: PlantConfigurationNotificationSubscribersPage,
      props: true,
      meta: {
        title: "Plant Configuration - Notifications",
        isPopup: true
      }
    },
    {
      path: '/plants/:plantID/configuration/alerts',
      name: 'plantConfigurationAlerts',
      component: PlantConfigurationAlertsPage,
      props: true,
      meta: {
        title: "Plant Configuration - Alerts",
        isPopup: true
      }
    },
    {
      path: '/plants/:plantID/activity',
      name: 'plantActivities',
      component: PlantActivities,
      props: true,
      meta: {
        title: "Activities",
        isPopup: true
      }
    },
    {
      path: '/crops/:cropID',
      name: 'cropExisting',
      component: CropAddEditPage,
      props: true,
      meta: {
        title: "Crop",
        isPopup: true
      }
    },
    {
      path: '/crops',
      name: 'cropNew',
      component: CropAddEditPage,
      props: true,
      meta: {
        title: "Crop",
        isPopup: true
      }
    },
    {
      path: '/crops/:cropLocationID/profiles',
      name: 'cropProfiles',
      component: CropProfilesPage,
      props: true,
      meta: {
        title: "Crop Profiles",
        isPopup: true
      }
    },
    {
      path: '/cropsbatch/:cropIDs',
      name: 'cropBatch',
      component: CropBatchEditEndDatePage,
      props: true,
      meta: {
        title: "Crop",
        isPopup: true
      }
    },
    {
      path: '/location/editgeodata/:LocationID',
      name: 'editLocation',
      component: EditLocationGeoData,
      meta: {
        title: "Edit Location GEO Data"
      }
    },
    {
      path: '/division/upload/:DivisionID',
      name: 'uploadDivision',
      component: UploadDivision,
      meta: {
        title: "Upload Division Data",
        isPopup: true
      }
    },
    {
      path:'/harvesting/forecasting',
      name: 'forecasting',
      component: ForecastingPage,
      meta: {
        title: "Forecasting",
        permissions: ['Portal Access', 'Forecasting and Rostering'],
        isTabletMode: true
      }
    },
    {
      path: '/maintenance/scouting',
      name: 'scouting',
      component: ScountingPage,
      meta: {
        title: "Scouting",
        permissions: ['Portal Access', 'Pest and Disease']
      }
    },
    {
      path: '/maintenance/trapinspection',
      name: 'trapinspection',
      component: TrapInspectionPage,
      meta: {
        title: "Trap Inspection",
        permissions: ['Portal Access', 'Pest and Disease']
      }
    },
    {
      path: '/maintenance/pestconfiguration',
      name: 'pestconfiguration',
      component: PestConfigurationPage,
      meta: {
        title: "Pest Configuration",
        permissions: ['Portal Access', 'Pest and Disease']
      }
    },
    {
      path: '/maintenance/trapconfiguration',
      name: 'trapconfiguration',
      component: TrapConfiguragionPage,
      meta: {
        title: "Trap Configuration",
        permissions: ['Portal Access', 'Pest and Disease']
      }
    },
    {
      path: '/maintenance/trapinspectionhistory/:trapID',
      name: 'trapinspectionhistory',
      component: TrapInspectionHistoryPage,
      meta: {
        title: "Trap Inspection History",
        permissions: ['Portal Access', 'Pest and Disease']
      }
    },
    {
      path: '/configuration/productgroups',
      name: 'productGroups',
      component: ProductGroupsPage,
      meta: {
        title: "Product Groups",
        permissions: ['Portal Access', FarmAdminAccessRight]
      }
    },
    {
      path: '/configuration/sprayconfiguration',
      name: 'sprayconfiguration',
      component: SprayConfigurationPage,
      meta: {
        title: "Spray Configuration",
        permissions: ['Portal Access', FarmAdminAccessRight]
      }
    },
    {
      path: '/harvesting/spray',
      name: 'sprayManagement',
      component: SprayManagementPage,
      meta: {
        title: "Spray Management",
        permissions: ['Portal Access', 'View and Edit Spray Management']
      }
    },
    {
      path: '/harvesting/nupointsprayjobs',
      name: 'nuPointSprayManagement',
      component: NuPointSprayJobsPage,
      meta: {
        title: "NuPoint Spray Management",
        permissions: ['Portal Access', 'View and Edit Spray Management']
      }
    },
    {
      path: '/harvesting/rostering',
      name: 'rosterManagement',
      component: RosterPage,
      meta: {
        title: "Rostering Management",
        permissions: ['Portal Access', 'Forecasting and Rostering']
      }
    },
    {
      path: '/harvesting/harvestplan',
      name: 'harvestPlan',
      component: HarvestPlanPage,
      meta: {
        title: "Daily Harvest Plan",
        permissions: ['Portal Access', 'Forecasting and Rostering']
      }
    },
    {
      path: '/test/weather',
      name: 'weather',
      component: TestWeatherPage,
      meta: {
        title: "Weather",
        isPopup: true
      }
    },
    {
      path: '/configuration/roles',
      name: 'Roles',
      component: RolesSettingsPage,
      meta: {
        title: "Roles",
        permissions: ['Portal Access', GlobalAdminAccessRight]
      }
    },
    {
      path: '/preceda/personnelmovements',
      name: 'PersonnelMovements',
      component: PersonnelMovements,
      meta: {
        title: "Personnel Movements",
        permissions: ['Portal Access', 'Personnel Management']
      }
    },
    {
      path: '/preceda/personnelmovementshistory',
      name: 'PersonnelMovementsHistory',
      component: PersonnelMovementsHistory,
      meta: {
        title: "Personnel Movements History",
        permissions: ['Portal Access', 'Preceda Management']
      }
    },
    {
      path: '/kingdee/personnelmovements',
      name: 'PersonnelMovementsKingdee',
      component: PersonnelMovements,
      meta: {
        title: "Personnel Movements",
        permissions: ['Portal Access', 'Kingdee Management']
      }
    },
    {
      path: '/kingdee/personnelmovementshistory',
      name: 'PersonnelMovementsHistoryKingdee',
      component: PersonnelMovementsHistory,
      meta: {
        title: "Personnel Movements History",
        permissions: ['Portal Access', 'Kingdee Management']
      }
    },
    {
      path: '/preceda/contractorexport',
      name: 'contractorExport',
      component: ContractorExportPage,
      meta: {
        title: "Contractor Export",
        permissions: ['Portal Access', 'Preceda Management']
      }
    },
    {
      path: '/preceda/cropworkexport',
      name: 'cropWorkExport',
      component: CropWorkExportPage,
      meta: {
        title: "Crop Work Export",
        permissions: ['Portal Access', 'Preceda Management']
      }
    },
    {
      path: '/configuration/berriesforecastnotealertcategories',
      name: 'berriesforecastnotealertcategories',
      component: BerriesforecastnotealertcategoriesPage,
      meta: {
        title: "Berries Forecast Note/Alert Categories",
        permissions: ['Portal Access', FarmAdminAccessRight]
      }
    },
    {
      path: '/configuration/attributes',
      name: 'attributes',
      component: AttributesPage,
      meta: {
        title: "Attributes",
        permissions: ['Portal Access', FarmAdminAccessRight] 
      }
    },
    {
      path: '/configuration/scoutingCropStages',
      name: 'scoutingCropStages',
      component: ScoutingCropStagesPage,
      meta: {
        title: "Scouting Crop Stages",
        permissions: ['Portal Access', FarmAdminAccessRight] 
      }
    },
    {
      path: '/configuration/scoutingScoreScales',
      name: 'scoutingScoreScales',
      component: ScoutingScoreScalesPage,
      meta: {
        title: "Scouting Score Scales",
        permissions: ['Portal Access', FarmAdminAccessRight] 
      }
    },
    {
      path: '/configuration/pestClassifications',
      name: 'pestClassifications',
      component: PestClassificationsPage,
      meta: {
        title: "Pest Classifications",
        permissions: ['Portal Access', FarmAdminAccessRight] 
      }
    },
    {
      path: '/configuration/allowancetypes',
      name: 'AllowanceTypes',
      component: AllowanceTypesPage,
      meta: {
        title: "Allowance Types",
        permissions: ['Portal Access', GlobalAdminAccessRight] 
      }
    },
    {
      path: '/plants/:plantID/rejections',
      name: 'Reject Punnets',
      component: RejectedPunnetsPage,
      meta: {
        title: "Reject Punnets",
        permissions: ['Portal Access', 'Reject Punnets'],
        isPopup: true
      }
    },
    {
      path: '/configuration/assets',
      name: 'assets',
      component: AssetsPage,
      meta: {
        title: "Assets",
        permissions: ['Portal Access', FarmAdminAccessRight] 
      }
    },
    {
      path: '/plants/:plantID/configuration/inductions',
      name: 'plantConfigurationInductions',
      component: PlantConfigurationInductionsPage,
      meta: {
        title: "Plant Configuration - Site Inductions",
        permissions: ['Portal Access'],
        isPopup: true
      }
    },
    
    {
      path: '/configuration/holidays',
      name: 'holidayConfiguration',
      component: HolidaySettingsPage,
      meta: {
        title: "Public Holidays",
        permissions: ['Portal Access', GlobalAdminAccessRight]
      }
    },

    {
      path: '/plants/Teams/attendanceMember/:attendanceAndMemberID',
      name: 'AttendanceMemberAbsence',
      component: AttendanceMemberAbsence,
      meta: {
        title: "Attendance Member Absences",        
        isPopup: true
      }
    },

    {
      path: '/plants/Teams/cropWorkAttendanceMember/:cropWorkAttendanceAndMemberID',
      name: 'CropWorkAttendanceMemberAbsence',
      component: CropWorkAttendanceMemberAbsence,
      meta: {
        title: "Crop Work Attendance Member Absences",        
        isPopup: true
      }
    },
    {
      path: '/plants/Teams/attendance/',
      name: 'BreaksAndMoves',
      component: BreaksAddEditPage,
      meta: {
        title: "Breaks / Moves",
        isPopup: true
      }
    },
    {
      path: '/plants/departmentcodes/:departmentCodeID',
      name: 'DepartmentCodeRates',
      params: true,
      component: departmentCodeRateList,
      meta: {
        title: "Department Code Rates",
        isPopup: true
      }
    }
  ]
})

// Global route guard
router.beforeEach((to, from, next) => {
  // Use the page's router title to name the page
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  store.commit("GeneralStore/setLoadingRoute", true);

  // Check if not authenticated
  authService.acquireToken().then(async () => {
    if (!to.meta.isPopup) {
      try {
        await store.dispatch("UserStore/loadUserAsync");
      } catch (error) {
        if (to.name === "loggingin") {
          console.log(error)
          router.push({
            path: "/loginerror"
          });

          next();
          return;
        } else {
          console.log("Assume Offline");
        }
      }
    }

    store.commit("GeneralStore/setLoadingRoute", false);

    // Check if we are going to the login error page (this would indicate a failed load of user from server - i.e., something wrong with system user rather than AD user)
    if (to.name === "loginerror") {
      // Display the page
      next();
      return;
    }

    // Check if we are going to the logout page (this would indicate a request to log out)
    if (to.name === "logout") {
      // Clear user cache
      store.dispatch("UserStore/clearUserCache").then(() => {
        // Redirect user to AD logout  
        authService.signOut(to.query.localOnly);
        if (to.query.localOnly) {
          next({
            path: "/loggedout"
          });
        } else {
          next();
        }
      });


      return;
    }

    // Check if we are going to the logged out page (this would indicate a user has refreshed/navigated to the logged out page,
    // which is not really useful if they are logged in)
    if (to.name === "loggedout") {
      // Redirect to the default page 
      next({
        path: "/"
      });
      return;
    }

    // Check if this is the first time we have been authenticated (this would indicate a redirect back from AD login)
    if (!store.getters["UserStore/isLoaded"]) {
      // Redirect to the logging in page 
      next({
        path: "/loggingin"
      });
      return;
    }
    // Check if we need authorisation to this route
    if (to.meta && to.meta.permissions && to.meta.permissions.length > 0) {      
      if (!store.getters["UserStore/isAuthorised"]({ accessRights: to.meta.permissions, path: to.path})) {
        next({
          path: "/notauthorized"
        });
        return;
      }
    }

    // Either user is authorized to see the page or no authorisation applied to the page
    // Display the page
    next();
    return;
  }).catch(err => {
    console.log("[Router Error]", err);
    store.commit("GeneralStore/setLoadingRoute", false);

    // Check if failure is from the user and not the token
    if (err.userError) {
      next({
        path: "/loginerror"
      });
      return;
    }

    // From here onwards we are not authenticated

    // Since we are not authenticated, forget what we know about the user (i.e., in the case of login expire)
    store.dispatch("UserStore/clearUserCache").then(() => {
      // Check if we are going to the login page (this would indicate a request to log in)
      if (to.name === "login") {
        // Redirect user to AD login
        authService.signIn();
        next();
        return;
      }

      // Check if we are going to the logout page (this would indicate a redirect back from AD logout)
      if (to.name === "loggedout") {
        // This is fine, display the page
        next();
        return;
      }

      // Check if we are going to the logout page (this would indicate a request to log out)
      if (to.name === "logout") {
        // Redirect user to AD logout 
        next({
          path: "/loggedout"
        });
        return;
      }

      // Go to the login page
      next({
        path: "/login"
      });
      return;
    })
  });
});

export default router;
